import {
  Client,
  ClientPersonalField,
  ClientOccupationField,
  EDUCATION,
  INDUSTRIES,
  MARITAL_STATUS,
  OCCUPATIONS,
} from '@insurgrid/common';
import { useFormContext } from 'react-hook-form';
import { BiPhone } from '@react-icons/all-files/bi/BiPhone';
import { Input, PhoneNumberInput } from './Input';
import { FormSearchableDropdown } from './FormSearchableDropdown';
import { HiLockClosed } from '@react-icons/all-files/hi/HiLockClosed';

export function ClientPersonalQuestionsForm(
  props: ClientPersonalField & { defaultValue?: Client },
) {
  return (
    <div className="space-y-5">
      <PhoneNumberInput
        data-test-id="phone"
        formattingInState
        type="tel"
        format="(###) ###-####"
        label="Phone number"
        name="client.phone"
        leftIcon={BiPhone}
        className="!text-sm"
      />
      <Input
        name={`${props.name}.email`}
        label={'Email address'}
        data-test-id={'email'}
        leftIcon={HiLockClosed}
      />
      <FormSearchableDropdown
        items={MARITAL_STATUS}
        name={`${props.name}.maritalStatus`}
        label="Marital status"
        defaultValue={props.defaultValue?.maritalStatus}
        dropdownStyles={{ maxHeight: '9.75rem' }}
        data-test-id="maritalStatus"
      />
      <FormSearchableDropdown
        items={[
          { label: 'Male', value: 'Male' },
          { label: 'Female', value: 'Female' },
          { label: 'Prefer not to answer', value: 'Prefer not to answer' },
        ]}
        label="Gender"
        name={`${props.name}.gender`}
        defaultValue={props.defaultValue?.gender}
        dropdownStyles={{ maxHeight: '9.75rem' }}
        data-test-id="gender"
      />
    </div>
  );
}

export function ClientOccupationQuestionsForm(
  props: ClientOccupationField & { defaultValue?: Client },
) {
  const { watch } = useFormContext();

  const industry: keyof typeof OCCUPATIONS | undefined = watch(
    `${props.name}.industry`,
  );

  const occupationName = `${props.name}.occupation`;

  return (
    <div className="space-y-5">
      <FormSearchableDropdown
        items={EDUCATION}
        name={`${props.name}.educationLevel`}
        label="Education level"
        defaultValue={props.defaultValue?.educationLevel}
        dropdownStyles={{ maxHeight: '10rem' }}
        data-test-id="educationLevel"
      />
      <FormSearchableDropdown
        name={`${props.name}.industry`}
        items={INDUSTRIES}
        label="Industry"
        data-test-id="industry"
        defaultValue={props.defaultValue?.industry}
        dropdownStyles={{ maxHeight: '10rem' }}
      />
      <FormSearchableDropdown
        name={occupationName}
        label="Occupation"
        items={industry ? OCCUPATIONS[industry] : []}
        defaultValue={props.defaultValue?.occupation}
        data-test-id="occupation"
        dropdownStyles={{ maxHeight: '10rem' }}
      />
    </div>
  );
}
